import React from "react";

import { Chip } from "@mui/material";
import mainStyles from "styles";

import { SubscriptionSeatTypes } from "@safetyculture/s12-apis-connect-web/s12/common/seat_types_pb";

import { subscriptionSeatTypesMapping } from "constants/seats";

interface UserSeatTypeChipProps {
  seatType: SubscriptionSeatTypes;
}

const UserSeatTypeChip = ({ seatType }: UserSeatTypeChipProps) => {
  const classes = mainStyles();

  let chipClass = classes.neutral;
  switch (seatType) {
    case SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_PREMIUM:
      chipClass = classes.purpleRain;
      break;
    case SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_LITE:
      chipClass = classes.greenDay;
      break;
    case SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_COLLABORATOR:
      chipClass = classes.blueMoon;
  }

  return (
    <Chip
      size="small"
      color="primary"
      sx={{ ...chipClass, fontWeight: "bold", marginBottom: "3px" }}
      label={subscriptionSeatTypesMapping[seatType]}
      data-testid="user-seat-type-chip"
    />
  );
};

export default UserSeatTypeChip;
